
  export default {
    name: 'MetaNavigation',
    props: {
      type: {
        type: String,
        required: false,
        default: 'full',
      },
    },
    computed: {
      navigationItems() {
        return [
          {
            translationKey: 'action.login',
            url: process.env.NUXT_ENV_LEGACY_URL,
            target: '_blank',
            divider: true,
            show: true,
          },
          {
            translationKey: 'organization.contact',
            route: this.localePath({
              name: 'organization-slug',
              params: {slug: 'kontaktdaten'},
            }),
            divider: true,
            show: true,
          },
          {
            translationKey:
              this.type === 'reduced'
                ? 'action.candidate'
                : 'organization.find_jobs',
            route: this.localePath({
              name: this.type === 'reduced' ? 'index' : 'jobs',
            }),
            divider: false,
            show: true,
          },
        ];
      },
    },
  };
